import { get } from 'lodash';
import moment from 'moment';

import request from '@helpers/request';
import api from '@constants/endpoints';
import { PromotionActivityFormValue } from './PromotionActivityEditModal.types';
import IGame from '@interfaces/IGame';
import { IPromotionActivity, IPromotionActivityAction } from '@interfaces/IPromotionActivity';
import { getPostById, reset } from '@stores/postSelector';
import IPost from '@interfaces/IPost';

// получение списка игр
export async function fetchGameList(gameName: string): Promise<IGame[]> {
  return request(api.games.getList, { params: { filter: gameName } }).then((body) => {
    return get(body, ['data', 'body', 'content'], []).map((game: IGame) => ({
      label: game.name,
      value: game.id,
      image: game.image,
    }));
  });
}

// конвертирование объекта из Form ANTd в объект для запроса
export const mapValueToRequest = (values: PromotionActivityFormValue): IPromotionActivityAction => {
  const { name, date, postId, gameIds, locale, id, textL18nKey } = values;

  let data: IPromotionActivityAction = {
    name,
    postId,
    starts: date?.[0]?.format(),
    ends: date?.[1]?.format(),
    gameIds: gameIds?.map((item: Record<string, any>) => item.key),
    textL18nKey: textL18nKey,
  };

  if (locale) {
    data = {
      ...data,
      accountFilter: {
        locales: locale === 'all' ? [] : [locale],
      },
    };
  }

  if (id) {
    data = { ...data, id };
  }

  return data;
};

// конвертирование из объекта нотификации в объект для использования в Form ANTd
export const mapDataToFieldsValue = (values: IPromotionActivity): PromotionActivityFormValue => {
  const {
    id,
    name,
    postDto: { id: postId },
    starts,
    ends,
    filter,
    textL18n,
  } = values;

  return {
    id,
    name,
    postId: postId.toString(),
    date: [moment(starts), moment(ends)],
    textL18nKey: textL18n,
    locale: filter?.locales?.[0] as PromotionActivityFormValue['locale'],
  };
};

// правила валидации формы
export const rulesValidateForm = {
  name: {
    base: {
      required: true,
      whitespace: true,
    },
  },
  postId: {
    base: { required: true },
    validator: (rule: any, value: string, content: Record<string, string>) => {
      if (value) {
        return getPostById(value)
          .catch(() => Promise.reject(content.valid_post_not_found))
          .then(({ data }: { data: IPost }) => {
            const { isBlocked, isHidden, isSpam } = data;
            if (isBlocked || isHidden || isSpam) {
              reset();
              return Promise.reject(content.valid_post_not_available);
            }
            return Promise.resolve();
          });
      } else {
        reset();
      }
      return Promise.resolve();
    },
  },
  date: {
    base: {
      required: true,
    },
  },
  textL18nKey: {
    base: {
      required: true,
    },
  },
};
